 "use client"

import { ReactNode } from "react"
import {type Session} from "next-auth"
import { ReCaptchaProvider } from "next-recaptcha-v3"
import { ThemeProvider } from "next-themes"
import {SessionProvider} from "next-auth/react"

import { ChatbotProvider } from "@/context/chatbot-provider"

export default function Providers({ children, session }: { children: ReactNode, session: Session }) {
    return (
        <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
            <ReCaptchaProvider reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}>
                <ChatbotProvider>
                    <SessionProvider session={session}>
                        {children}
                    </SessionProvider>
                </ChatbotProvider>
            </ReCaptchaProvider>
        </ThemeProvider>
    )
}
